export default {
  namespaced: true,
  hanwha_log: {
    title: "DVR Registros",
    dvr: "Grabador (DVR)",
    autoDetectDvr: "Detectar DVR(s) automáticamente",
    autoDetectDvrHint: "Usa el/los DVR(s) de la unidad de la alarma en automático",
    typeLog: "Tipo de log",
    typeEvent: "Tipo de evento",
    dateRange: "Rango de días",
    dateRangeNone: "Ninguno",
    dateRangeLast30: "Últimos 30 días",
    dateRangeLast60: "Últimos 60 días",
    dateRangeHint: "Se calcula desde el momento en que se abre la vista de la alarma",
  },
};
